import React from 'react';
import { parseISO, format } from 'date-fns';
import TimeSlotButton from './TimeSlotButton';

function TimeSlotPicker({ availableTimes, onTimeSelect, selectedTime }) {
  if (!availableTimes || availableTimes.length === 0) return null;

  // Group time slots by hour (local time)
  const groupedByHour = availableTimes.reduce((acc, { start, title }) => {
    const localDate = parseISO(start);
    const hour = format(localDate, 'h a'); // e.g., "9 AM", "4 PM"
    if (!acc[hour]) acc[hour] = [];
    acc[hour].push({ start, title });
    return acc;
  }, {});

  return (
    <div className="space-y-1">
      {Object.entries(groupedByHour).map(([hourLabel, slots], index) => (
        <div
          key={hourLabel}
          className={`my-0 rounded p-2 ${index % 2 === 0 ? 'bg-secondary-light' : 'bg-gray-100'}`}
        >
          <h4 className="text-sm font-semibold text-gray-700 mb-1">{hourLabel}</h4>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
            {slots.map(({ start, title }) => (
              <TimeSlotButton
                key={start}
                start={start}
                isAvailable={title === 'available'}
                isSelected={start === selectedTime}
                onSelect={onTimeSelect}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
  
}

export default TimeSlotPicker;
